import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { AlertCircle } from 'lucide-react';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const { login, isLoading } = useAuth();
  const nav = useNavigate();

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    try {
      await login(email, password);
      nav('/app');
    } catch (err: any) {
      setError(err?.response?.data?.error ?? 'Connexion échouée');
    }
  };

  return (
    <div className="h-full flex items-center justify-center bg-bg">
      <form onSubmit={onSubmit} className="card card-pad w-96 space-y-4">
        <div className="flex items-center gap-2 pb-2 border-b border-border">
          <div className="w-6 h-6 rounded-full bg-brand animate-firefly" />
          <span className="text-lg font-semibold">Filos<span className="text-text-faint font-normal"> · ACS</span></span>
        </div>

        <div>
          <label className="text-xs text-text-muted block mb-1.5">Email</label>
          <input
            className="input w-full"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            autoFocus
            required
          />
        </div>

        <div>
          <label className="text-xs text-text-muted block mb-1.5">Password</label>
          <input
            className="input w-full"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        {error && (
          <div className="flex items-start gap-2 p-2 bg-danger-dim border border-danger/30 rounded text-xs">
            <AlertCircle size={13} className="text-danger shrink-0 mt-0.5" />
            <div className="text-danger">{error}</div>
          </div>
        )}

        <button type="submit" disabled={isLoading} className="btn btn-primary w-full h-9 justify-center text-sm font-medium">
          {isLoading ? 'Connexion…' : 'Se connecter'}
        </button>
      </form>
    </div>
  );
}
